module.exports = __webpack_public_path__ + "img/title-4-3b1e36.png";